import React from 'react';
import { DARK_SECTION, LIGHT_SECTION, FONTS } from '../constants/theme';
import { FaPhone, FaEnvelope } from 'react-icons/fa';

const LodgingPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* ヘッダーセクション */}
      <section className="relative h-screen overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/images/lodging/header.jpg')" }}
        ></div>
        <div className={`absolute inset-0 ${DARK_SECTION.GRADIENT.HERO}`}></div>

        <div className="absolute inset-0 flex items-end">
          <div className="container mx-auto px-6 pb-20">
            <h1
              className={`${DARK_SECTION.TEXT.DEFAULT} font-serif text-6xl md:text-8xl font-light mb-6 tracking-wide`}
            >
              宿泊案内
            </h1>
            <p
              className={`${DARK_SECTION.TEXT.SEMI_MUTED} text-xl md:text-2xl max-w-2xl leading-relaxed`}
            >
              静寂に包まれた山の宿で、都市の喧騒を忘れる特別な時間を
            </p>
          </div>
        </div>
      </section>

      {/* 宿泊施設一覧 */}
      <section className={`py-24 ${LIGHT_SECTION.BG.PRIMARY}`}>
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 max-w-7xl mx-auto">
            {/* ウェストロッジ */}
            <div>
              <div className="relative overflow-hidden bg-white shadow-lg">
                {/* メイン画像 */}
                <div
                  className="h-64 bg-cover bg-center"
                  style={{
                    backgroundImage: "url('/images/lodging/west/main.jpg')",
                  }}
                ></div>

                <div className="p-8">
                  <div className="flex items-center justify-between mb-4">
                    <h2
                      className={`${LIGHT_SECTION.TEXT.DEFAULT} text-2xl font-light tracking-wider`}
                    >
                      ウェストロッジ
                    </h2>
                    <div
                      className={`w-8 h-px ${LIGHT_SECTION.ACCENT.BG}`}
                    ></div>
                  </div>

                  <p
                    className={`${LIGHT_SECTION.TEXT.MUTED} mb-6 leading-relaxed text-sm`}
                  >
                    シンプルながらも落ち着いた雰囲気のツインルーム
                  </p>

                  <div className="space-y-3 mb-6">
                    <div className="flex justify-between">
                      <span className={`${LIGHT_SECTION.TEXT.SLIGHT_MUTED}`}>
                        シングルユース
                      </span>
                      <span
                        className={`${LIGHT_SECTION.TEXT.DEFAULT} font-medium`}
                      >
                        ¥11,000/1名
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`${LIGHT_SECTION.TEXT.SLIGHT_MUTED}`}>
                        ツインユース
                      </span>
                      <span
                        className={`${LIGHT_SECTION.TEXT.DEFAULT} font-medium`}
                      >
                        ¥6,600/1名
                      </span>
                    </div>
                    <div className={`${LIGHT_SECTION.TEXT.MUTED} text-sm mt-2`}>
                      ロフト 布団1組につき ¥3,300
                    </div>
                  </div>

                  <div
                    className={`${LIGHT_SECTION.BG.PRIMARY_LIGHT} p-6 space-y-3`}
                  >
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          客室数
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          3部屋
                        </span>
                      </div>
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          定員
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          2〜4名/部屋
                        </span>
                      </div>
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          バス・トイレ
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          完備
                        </span>
                      </div>
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          暖房
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          あり
                        </span>
                      </div>
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          電波
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          なし
                        </span>
                      </div>
                    </div>
                    <div
                      className={`border-t ${LIGHT_SECTION.TEXT.MUTED} pt-3`}
                    >
                      <span
                        className={`${LIGHT_SECTION.TEXT.MUTED} text-sm block mb-1`}
                      >
                        アメニティ
                      </span>
                      <span
                        className={`${LIGHT_SECTION.TEXT.SEMI_MUTED} text-sm`}
                      >
                        タオル、バスタオル、歯ブラシセット
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* イーストロッジ */}
            <div>
              <div className="relative overflow-hidden bg-white shadow-lg">
                {/* メイン画像 */}
                <div
                  className="h-64 bg-cover bg-center"
                  style={{
                    backgroundImage: "url('/images/lodging/east/main.jpg')",
                  }}
                ></div>

                <div className="p-8">
                  <div className="flex items-center justify-between mb-4">
                    <h2
                      className={`${LIGHT_SECTION.TEXT.DEFAULT} text-2xl font-light tracking-wider`}
                    >
                      イーストロッジ
                    </h2>
                    <div
                      className={`w-8 h-px ${LIGHT_SECTION.ACCENT.BG}`}
                    ></div>
                  </div>

                  <p
                    className={`${LIGHT_SECTION.TEXT.MUTED} mb-6 leading-relaxed text-sm`}
                  >
                    本格的な山小屋スタイルの共同宿泊スペース
                  </p>

                  <div className="space-y-3 mb-6">
                    <div className="flex justify-between">
                      <span className={`${LIGHT_SECTION.TEXT.SLIGHT_MUTED}`}>
                        5名様〜
                      </span>
                      <span
                        className={`${LIGHT_SECTION.TEXT.DEFAULT} font-medium`}
                      >
                        ¥5,500/1名
                      </span>
                    </div>
                  </div>

                  <div
                    className={`${LIGHT_SECTION.BG.PRIMARY_LIGHT} p-6 space-y-3`}
                  >
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          定員
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          20名
                        </span>
                      </div>
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          バス・トイレ
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          共同
                        </span>
                      </div>
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          暖房
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          あり
                        </span>
                      </div>
                      <div>
                        <span className={`${LIGHT_SECTION.TEXT.MUTED} block`}>
                          電波
                        </span>
                        <span className={`${LIGHT_SECTION.TEXT.DEFAULT}`}>
                          なし
                        </span>
                      </div>
                    </div>
                    <div
                      className={`border-t ${LIGHT_SECTION.TEXT.MUTED} pt-3`}
                    >
                      <span
                        className={`${LIGHT_SECTION.TEXT.MUTED} text-sm block mb-1`}
                      >
                        アメニティ
                      </span>
                      <span
                        className={`${LIGHT_SECTION.TEXT.SEMI_MUTED} text-sm`}
                      >
                        タオル、バスタオル、歯ブラシセット
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ご予約に関するご案内 */}
      <section
        className={`pb-24 ${LIGHT_SECTION.BG.PRIMARY} relative overflow-hidden`}
      >
        <div className="container mx-auto px-6 max-w-4xl relative z-10">
          <div className="bg-white shadow-lg p-8 md:p-12 text-center">
            <span
              className={`text-xs font-semibold tracking-widest uppercase block mb-2 ${LIGHT_SECTION.ACCENT2.DEFAULT}`}
            >
              Reservation & Contact
            </span>
            <h3
              className={`${FONTS.SERIF} text-2xl md:text-3xl font-light mb-4 ${LIGHT_SECTION.TEXT.DEFAULT} tracking-wider`}
            >
              ご予約・お問い合わせ
            </h3>
            <p
              className={`${LIGHT_SECTION.TEXT.MUTED} text-sm md:text-base leading-relaxed mb-10 max-w-2xl mx-auto`}
            >
              ご宿泊のお申し込みや空室状況のご確認は、お電話またはメールにて承っております。
              <br />
              ご希望のご宿泊日、人数、ご利用予定のロッジなどをお気軽にお問い合わせください。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 max-w-2xl mx-auto">
              {/* お電話 */}
              <a
                href="tel:0265729990"
                className={`${LIGHT_SECTION.BG.PRIMARY_LIGHT} hover:bg-natural-light/60 flex items-center justify-center gap-4 p-4 shadow-sm transition-all duration-300 w-full sm:w-1/2 group`}
              >
                <div
                  className={`${LIGHT_SECTION.TEXT.DEFAULT} group-hover:${LIGHT_SECTION.ACCENT.DEFAULT} transition-colors duration-300`}
                >
                  <FaPhone className="text-lg" />
                </div>
                <div className="text-left">
                  <span
                    className={`text-[10px] block ${LIGHT_SECTION.TEXT.MUTED} tracking-widest uppercase`}
                  >
                    TEL
                  </span>
                  <span
                    className={`text-base font-medium tracking-wide ${LIGHT_SECTION.TEXT.DEFAULT}`}
                  >
                    0265-72-9990
                  </span>
                </div>
              </a>

              {/* メール */}
              <a
                href="mailto:lodgemilk1982@gmail.com"
                className={`${LIGHT_SECTION.BG.PRIMARY_LIGHT} hover:bg-natural-light/60 flex items-center justify-center gap-4 p-4 shadow-sm transition-all duration-300 w-full sm:w-1/2 group`}
              >
                <div
                  className={`${LIGHT_SECTION.TEXT.DEFAULT} group-hover:${LIGHT_SECTION.ACCENT.DEFAULT} transition-colors duration-300`}
                >
                  <FaEnvelope className="text-lg" />
                </div>
                <div className="text-left">
                  <span
                    className={`text-[10px] block ${LIGHT_SECTION.TEXT.MUTED} tracking-widest uppercase`}
                  >
                    MAIL
                  </span>
                  <span
                    className={`text-xs md:text-sm font-medium tracking-wide ${LIGHT_SECTION.TEXT.DEFAULT}`}
                  >
                    lodgemilk1982@gmail.com
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LodgingPage;
